import React from 'react';
import { Box } from '@mui/material';
import Application from '../../components/application';
import AcompCoordenador from './acompCoordenador';

const Acompanhamento = () => {
  return (
    <Application>
      <Box sx={{ width: '100%', minHeight: 'calc(100vh - 64px)', p: { xs: 1, sm: 2 } }}>
        <AcompCoordenador />
      </Box>
    </Application>
  );
};

export default Acompanhamento;